import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Pagination } from '@mui/material';
import ShowLoading from "../../components/ShowLoading";
import ShowError from "../../components/ShowError";
import { ThemeProvider } from '@mui/material';
import muiTheme from "../../components/muiTheme";
import { getLifafasByPage, getTotalLifafaPages } from "../helper/userapi";
import LifafaCard from "./LifafaCard";

function ListLifafas(_props) {

    const user = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [lifafas, setLifafas] = useState([]);

    const setTotalLifafaPages = () => {
        getTotalLifafaPages(user._id, user.token)
            .then(data => {
                if (data?.error) {
                    setError(data.error);
                } else {
                    setTotalPages(data.totalPages);
                }
                setIsLoading(false)
            })
            .catch(err => console.log(err) && isLoading(false))
    }

    const setLifafasData = (page) => {
        getLifafasByPage(user._id, { page, pageSize }, user.token)
            .then(data => {
                if (data?.error) {
                    setError(data.error);
                } else if (data) {
                    setLifafas(data);
                }
                setIsLoading(false)
            })
            .catch(err => console.log(err) && isLoading(false))
    }

    useEffect(() => {
        setTotalLifafaPages();
        setLifafasData(pageNumber);
    }, []);

    const handlePageChange = (event, page) => {
        event.preventDefault();
        setIsLoading(true);
        setLifafasData(page);
        setPageNumber(page);
    }

    return (
        <div>
            <ShowError error={error} />
            <ShowLoading isLoading={isLoading} />
            <>
                {lifafas && lifafas?.map((lifafa) => <LifafaCard key={lifafa._id} lifafa={lifafa} />)}
                {lifafas?.length < 1 && <>
                    <div className="card fw-bold text-center p-5 shadow-lg">
                        <div className=" m-auto mb-5">
                            <lord-icon
                                src="https://cdn.lordicon.com/ncxoarcp.json"
                                trigger="loop"
                                delay="1000"
                                colors="primary:#892cdc"
                                style={{ width: "250px", height: "250px" }}>
                            </lord-icon>
                        </div>
                        <h3>You don't have any lifafa!</h3>
                        <h3 className="mt-5">Click on 'Create Lifafa' to create one!</h3>
                    </div>
                </>}
                {totalPages > 1 && <ThemeProvider theme={muiTheme}><div className="mt-4"><Pagination count={totalPages} color="purple" size="large" onChange={handlePageChange} page={pageNumber} /></div></ThemeProvider>}
            </>
        </div>
    );
}

export default ListLifafas;